import React from 'react';
import { Heading } from '@scentregroup/ui';
import PotentialLink from '../../auto-potential-link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const ArticleHeading = _ref => {
  let {
    children,
    link,
    type,
    dataTestId
  } = _ref;
  return /*#__PURE__*/_jsx(PotentialLink, {
    link: link,
    className: style.link,
    "data-id": "article-heading_index_ArticleHeading_PotentialLink",
    children: /*#__PURE__*/_jsx(Heading, {
      type: type,
      "data-test-id": dataTestId,
      "data-id": "article-heading_index_ArticleHeading_PotentialLink_Heading",
      children: children
    })
  });
};
ArticleHeading.defaultProps = {
  type: 'large'
};
export default ArticleHeading;